import {EventEmitter, Injectable} from '@angular/core';
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {IPlatformToolHandler} from "@shared/components/platform-tool/platform-tool-container/platform-tool-component";
import {DialogModel} from "@shared/models/dialog.model";
import {take} from 'rxjs/operators';
import {DialogService} from "@shared/services/dialog-service";
import {FuseSplashScreenService} from "@barebone-fuse-services/splash-screen.service";
import {CommandService} from "@core/services/command.service";
import {MagicLinkModel, TabModel} from "@shared/models/platform-tool-models";
import {PlatformCommand, PlatformCommandResponse} from "@shared/commands/command-base";
import { Subject } from 'rxjs';
import {Api} from "@shared/constants/common-field.constants";
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from '@core/services/snack-bar.service';
import { FileManagementService } from '@core/services/file-management.service';
@Injectable({
  providedIn: 'root'
})
export class CbcScenarioHandler implements IPlatformToolHandler{
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any> = new EventEmitter<any>();
  sourceType: string;
  unsubscribe$ = new Subject<void>();

  constructor(private dialogService: DialogService,
              private snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private fuseSplashScreenService: FuseSplashScreenService,
              private commandService: CommandService,
              private router: Router,) {
  }


  valueChanged(event) {
        switch (event.action.id) {
          case 'Edit':
            this.edit(event);
            break;
          case 'Refresh':
            this.refresh(event);
            break;
          case 'OpenNote':
            this.handleNoteDialogByKey(event, 'NoteDialogEditorComponent');
            break;
          case 'GenerateCbCMemo':
            this.GenerateMemo(event);
            break;
          case 'GenerateTlLetter' :
            this.generateTlLetter(event);
            break;
          case 'Hyperlink' :
            this.ridirectToLink(event);
            break;
      }
    }

  ridirectToLink(event){
    const command = this.magicLinkModel.additionalCommands[event.fieldDefinition.key];
      if (command.name == "CbcExchangeToolLinkCommand") {
        var hasJurisdiction = event.item.cells.SurrogateJurisdiction.displayText != "No Surrogate";

        if(hasJurisdiction){
          command.fieldValues["Country1"] = event.item.cells.Country1Code.displayText;
          command.fieldValues["Country2"] = event.item.cells.Country2Code.displayText;
          this.executeCommand(command);
        }
      
      }
  }

  edit(event) {

    if(this.editHandleByDialog(event))
    {
      return;
    }
    if(this.handleByFieldDefinitionMetadata(event))
    {
      return;
    }
    if (event.item.cells[event.fieldDefinition.key].metaData?.Command) {
      const command = event.item.cells[event.fieldDefinition.key].metaData.Command;
      this.executeCommandToApi(command);
      return;
    }
  }
  handleByFieldDefinitionMetadata(event: any) {
    if(event.fieldDefinition?.metaData?.ExecutingCommand){
      let commandName = event.fieldDefinition?.metaData?.ExecutingCommand;
      let additionalCommand = this.magicLinkModel.additionalCommands[commandName];
      additionalCommand.fieldValues['ItemId'] = event.item.id;
      this.executeCommandToApi(additionalCommand);
      return true;
    }
    return false;
  }

  executeCommand(command: PlatformCommand, callBack?: any) {
    switch (command.name) {
      case 'CbcComplianceChangesCommand':
        this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
        return;
      default:
        break;
    }
    this.executeCommandToApi(command);
  }

  private refresh(event: any) {
    var command = new PlatformCommand('ResetCbCComplianceCommand', Api.DueDateTracker);
    command.setValue('ItemId', event.item.id);
    command.setValue('StrategyType', event.fieldDefinition.metaData?.ResetStrategyType);
    command.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(command);
  }

  private editHandleByDialog(event) {
    if(event.fieldDefinition.cellEditor){
      this.handleDialog(event, event.fieldDefinition.cellEditor);
      return true;
    }
    return false;
  }
  private handleDialog(event: any, componentName: string) {
    const dialogModel = DialogModel.create(event.fieldDefinition.header, componentName, {
      fieldDefinition : event.fieldDefinition,
      item : event.item
    });

    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(2)).subscribe(state => {
      if (state.action === 'OK') {
        if (dialogModel.input['HasUpdate']) {
          if(dialogModel.input['NextExecutionCommand']){
            let command = dialogModel.input['NextExecutionCommand'];
            this.setUpdateCbCComplianceGridFieldDataCommand(command);
            this.executeCommandToApi(command);
          }
        }
      }
    });
  }

  private handleNoteDialogByKey(event: any, componentName: string) {
    const dialogModel = DialogModel.create('More Information', componentName, {
      key : event.noteKey,
      item : event.item
    }, '400px', '600px ' , false, -1, '', '');

    this.dialogService.showOkCancelDialog(dialogModel).pipe(take(2)).subscribe(state => {
      if (state.action === 'OK') {}
    });
  }



  destroy(): void {
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            this.fuseSplashScreenService.hide();
            return;
          }
          else if (command.name === 'CbcExchangeToolLinkCommand' && commandResponse.fieldValues['PlatformLinkModel']) {
            this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
            this.magicLinkModelValueChanged.emit({ id: 'ToolItemsComponent', toolItems: this.magicLinkModel.breadcrumbBar });
            this.router.navigateByUrl('/cbc/library/exchange');
            return;
          }
          else if (commandResponse.fieldValues['PlatformLinkModel']) {
            this.refreshComponentWithBreadCrumb(commandResponse);
            this.fuseSplashScreenService.hide();
            return;
          }
          else if(commandResponse.fieldValues['RefreshMagicLink']){
            let refreshCommand = this.magicLinkModel.additionalCommands['UpdatePlatformLinkCommand'];
            this.executeCommandToApi(refreshCommand);
            this.fuseSplashScreenService.hide();
            return;
          }
          else if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          }
          else if(commandResponse.fieldValues['DownloadResponse']){
            this.fileManagementService.downloadClientFileWithId(commandResponse.fieldValues['DownloadResponse'].fileId).subscribe(payload => {
              this.fuseSplashScreenService.hide();
              this.fileManagementService.openSaveFileWindow(payload, `${commandResponse.fieldValues['DownloadResponse'].fileName}`);
            });
            return;
          }
          else if (commandResponse.fieldValues['SnackBarMessage']) {
            const duration = commandResponse.fieldValues['SnackBarMessageDuration'] ?? commandResponse.fieldValues['SnackBarMessage'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            this.fuseSplashScreenService.hide();
            return;
          }

          else if (commandResponse.fieldValues['ErrorMessage']) {
            this.snackBarService.showError(commandResponse.fieldValues['ErrorMessage']);
            this.fuseSplashScreenService.hide();
            return;
          }
          this.fuseSplashScreenService.hide();
          this.invalidateSubject.invalidate();
        },
        error => {
          console.error('Failed To Execute command', error);
          this.fuseSplashScreenService.hide();
      });
    }
  }
  setSelectedTab(selectedTab: TabModel): void {
  }

  private refreshComponentWithBreadCrumb(commandResponse: PlatformCommandResponse) {
    this.magicLinkModel = commandResponse.fieldValues['PlatformLinkModel'];
    this.magicLinkModelValueChanged.emit({ id: 'ToolItemsComponent', toolItems: this.magicLinkModel.breadcrumbBar });
    this.invalidateSubject.invalidate();
  }


  generateTlLetter(event) {
    var command = new PlatformCommand('TLLetterProcessCommand', Api.DueDateTracker);
    command.setValue('ItemId', event.item.id);
    command.setValue('DocumentType',"Word")
    command.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(command);
  }

  private GenerateMemo(event: any) {
    var command = new PlatformCommand('GenerateCbCMemoCommand', Api.DueDateTracker);
    command.setValue('ItemId', event.item.id);
    command.projectId = '[PROJECT_ID]';
    this.executeCommandToApi(command);
  }

  private setUpdateCbCComplianceGridFieldDataCommand(command: PlatformCommand){
    command.acknowledgeApi = Api.DueDateTracker;
    command.acknowledgementCommand = 'UpdateCbCComplianceGridFieldDataCommand';
  }
}
